<ng-container [formGroup]="virtualEvent">
    <app-header title="Virtual Event Editor"></app-header>
    <ng-container *ngIf="sponsorMode === 'list' && slideMode === 'list'">
        <div class="container pt-3">
            <div class="d-flex justify-content-between mb-3">
                <div class="campaign__title">Virtual Event</div>
                <div class="campaign__action-list d-flex align-items-center">
                    <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onCancel()">Cancel</button>
                    <button class="btn btn--paybee btn--success" (click)="onSave()">Save</button>
                </div>
            </div>
        </div>
        <mdb-tabs #tabs class="mdb-tabs" (activeTabChange)="onTabChange($event)" >
            <mdb-tab title="Virtual Event Configuration">
                <div class="background__color--white py-4">
                    <div class="container">
                        <div class="card__header">
                            <div class="card__title">General Information</div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <div class="position-relative mb-4 w-100">
                                    <div
                                        *ngIf="virtualEvent.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                                        class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                                    >
                                        <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                                    </div>
                                    <div
                                        *ngIf="virtualEvent.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                                        class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                                    >
                                        <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetImage()"></app-icon-delete>
                                    </div>
                                    <img style="border-radius: 5px" class="w-100" [src]="virtualEvent.controls.imageDataUrl.value">
                                </div>
                            </div>
                        </div>
                        <mdb-form-control class="form-fill">
                            <app-mdbp-input mdbInput formControlName="name" label='Event Name'></app-mdbp-input>
                            <span class="form-fill-error"  *ngIf="virtualEvent.controls.name.hasError('required') && virtualEvent.controls.name.touched ">Please provide Virtual Event Name</span>
                          </mdb-form-control>
                        <div class="position-relative mb-4">
                            <label class="form-check-label form-check-label--paybee mb-1">Campaign description</label>
                            <mdb-form-control class="mb-4">
                                <app-quill-custom mdbInput formControlName="desc" limit="512"></app-quill-custom>
                              </mdb-form-control> 
                        </div>
                        <div class="row justify-content-left">
                            <div class="col">
                                <mdb-form-control class="form-fill">
                                    <mdb-select formControlName="eventType" class="mdb-select">
                                      <mdb-option *ngFor=" let eventType of eventTypeList" [value]="eventType.value">{{
                                        eventType.label
                                      }}</mdb-option>
                                    </mdb-select>
                                    <label mdbLabel class="form-label form-label--paybee">Virtual Event Type</label>
                                </mdb-form-control>
                            </div>
                        </div>
                        <div class="row justify-content-left">
                            <div class="col" *ngIf="initialized">
                                <app-datetime
                                    dateLabel="Event Date"
                                    timeLabel="Event Time"
                                    [timezone]="virtualEvent.controls.timeZoneData.value.name"
                                    formControlName="startDateTimeGmtUnix"
                                    [required]="true"
                                    [submitted]="submitted"
                                    data-panel="info"
                                ></app-datetime>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <mdb-form-control class="form-fill" >
                                    <app-mdbp-input mdbInput formControlName="duration" [isCurrencyMask]="true" label='Duration in minutes'>
                                        <input  #inputNameC currencyMask [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" formControlName="duration" class="form-control form-control--paybee"/>
                                    </app-mdbp-input>
                                    <span class="form-fill-error"  *ngIf="virtualEvent.controls.duration.hasError('required') && virtualEvent.controls.duration.touched ">Please provide Virtual Event Duration</span>
                                    <span class="form-fill-error"  *ngIf="virtualEvent.controls.duration.hasError('min') && virtualEvent.controls.duration.touched  "> Duration should not be less than 1 min</span>
                                </mdb-form-control>
                            </div>
                            <div class="col-6" formGroupName="timeZoneData">
                                <mdb-form-control class="form-fill">
                                    <mdb-select formControlName="name" class="mdb-select">
                                      <mdb-option *ngFor=" let timeZone of timeZoneList" [value]="timeZone.value">{{
                                        timeZone.label
                                      }}</mdb-option>
                                    </mdb-select>
                                    <label mdbLabel class="form-label form-label--paybee">Time Zone</label>
                                  </mdb-form-control>
                            </div>
                        </div>
                        <mdb-accordion [multiple]="true">

                            <mdb-accordion-item>
                              <ng-template mdbAccordionItemHeader>Live Stream Info</ng-template>
                              <ng-template mdbAccordionItemBody>
                                <div class="row justify-content-left">
                                    <div class="col">
                                        <mdb-form-control class="form-fill">
                                            <mdb-select formControlName="streamProvider" class="mdb-select"  data-panel="stream">
                                              <mdb-option *ngFor=" let streamProvider of streamProviderList" [value]="streamProvider.value">{{
                                                streamProvider.label
                                              }}</mdb-option>
                                            </mdb-select>
                                            <label mdbLabel class="form-label form-label--paybee">Stream Provider</label>
                                          </mdb-form-control>
                                    </div>
                                </div>
                                <div class="row justify-content-left">
                                    <div class="col">
                                        <mdb-form-control class="form-fill">
                                            <app-mdbp-input maxLength="512"  mdbInput formControlName="streamUrl" label='Stream Url '  data-panel="stream"></app-mdbp-input>
                                        </mdb-form-control>
                                    </div>
                                </div>
                              </ng-template>
                            </mdb-accordion-item>

                            <mdb-accordion-item>
                              <ng-template mdbAccordionItemHeader>Event Settings</ng-template>
                              <ng-template mdbAccordionItemBody>
                                <app-mdb-switch  data-panel="settings" label="Guest will be asked for Street Address" formControlName="donorStreetAddressNeeded"></app-mdb-switch>
                                <app-mdb-switch  data-panel="settings" label="Guest will be asked for phone number" formControlName="donorPhoneNeeded"></app-mdb-switch>
                                <app-mdb-switch  data-panel="settings" label="Show pledge progress against goal to attendees" formControlName="showGoalToDonors"></app-mdb-switch>

                                <div class="row justify-content-left">
                                    <div class="col">
                                        <mdb-form-control class="form-fill"  data-panel="info" >
                                            <app-mdbp-input mdbInput formControlName="valueProvided" [isCurrencyMask]="true" label='Goal'data-panel="info">
                                                <input  #inputNameC currencyMask formControlName="valueProvided" class="form-control form-control--paybee" data-panel="info"/>
                                            </app-mdbp-input>
                                        </mdb-form-control>
                                    </div>
                                </div>
                                <app-mdb-switch label="Hide option for the donors to cover transaction fee" formControlName="hideDonorFee" data-panel="settings" ></app-mdb-switch>
                                <app-mdb-switch label="Ask donors for additional information" formControlName="additionalInfoRequired" data-panel="settings" ></app-mdb-switch>

                                <div style="padding-left: 44px;" *ngIf="virtualEvent.value.additionalInfoRequired">
                                    <mdb-form-control class="form-fill">
                                        <app-mdbp-input mdbInput formControlName="additionalInfoName" label='Additional Info Name' data-panel="settings" ></app-mdbp-input>
                                        <span class="form-fill-error"  *ngIf="virtualEvent.controls.additionalInfoName.hasError('required') && virtualEvent.controls.additionalInfoName.touched ">Please provide Additional Info Name</span>
                                    </mdb-form-control>
                                </div>
                                <div class="row">
                                    <div class="col-8 d-flex">
                                        <app-mdb-switch label="Allow donors to donate anonymously" formControlName="showAnonymous" data-panel="settings" ></app-mdb-switch>

                                            <div class="d-flex align-items-center ml-2 h-100">
                                            <a
                                            tabindex="0"
                                            class="btn mdbPopover"
                                            role="button"
                                            trigger="focus"
                                            mdbPopover="If selected allows donors to select being anonymous when they join the event. If the donor selects this option, other participants will not see the donor's name when shown in the activity list. Only applicable for donations, not for live auction or last hero game."
                                            >
                                            <i class="blue-text far fa-question-circle" aria-hidden="true"></i>
                                            <small class="blue-text mdb-popover-text">Help</small>
                                            </a
                                          >
                                        </div>
                                    </div>
                                </div>
                                <app-mdb-switch label="Show donate button" formControlName="defaultDonateCampaignRequired" data-panel="settings" ></app-mdb-switch>

                                <div style="padding-left: 44px;" *ngIf="virtualEvent.value.defaultDonateCampaignRequired">
                                    <ng-container *ngIf="campaigns$ | async as campaigns">
                                        <mdb-form-control class="form-fill">
                                            <mdb-select formControlName="defaultDonateCampaignId" class="mdb-select" data-panel="settings">
                                              <mdb-option *ngFor="let campaign of campaigns" [value]="campaign.id">{{
                                                campaign.name
                                              }}</mdb-option>
                                            </mdb-select>
                                            <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
                                            <span class="form-fill-error" *ngIf="virtualEvent.controls.defaultDonateCampaignId.hasError('required') && virtualEvent.controls.defaultDonateCampaignId.touched"> Please provide Co-Campaigns</span>
                                          </mdb-form-control>
                                    </ng-container>
                                </div>
                                <div class="row justify-content-left">
                                    <div class="col">
                                        <mdb-form-control class="form-fill">
                                          <mdb-select formControlName="pledgeBehaviour" class="mdb-select" data-panel="settings">
                                            <mdb-option *ngFor="let pledgeBehaviour of pledgeBehaviourList" [value]="pledgeBehaviour.value">{{
                                                pledgeBehaviour.label
                                            }}</mdb-option>
                                          </mdb-select>
                                          <label mdbLabel class="form-label form-label--paybee">Pledge Behavior</label>
                                        </mdb-form-control>
                                    </div>
                                </div>

                              </ng-template>
                            </mdb-accordion-item>

                            <mdb-accordion-item>
                                <ng-template mdbAccordionItemHeader>Music</ng-template>
                                <ng-template mdbAccordionItemBody>
                                    <div class="small text-muted">Lobby Music</div>
                                    <div class="row align-items-center">
                                        <div class="col-4" id="lobbyMusicCol"><audio id="lobbyMusicAudio" controls="" loop="" style="outline: none;"><source [src]="virtualEvent.value.lobbyMusic"></audio></div>
                                        <div class="col-2">
                                            <div class="file-field">
                                                <div class="d-flex justify-content-end">
                                                    <div (click)="onChangeMusic('lobby')" id="changeLobbyMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                                        <span class="blue-text">Change</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="file-field">
                                                <div class="d-flex justify-content-end">
                                                    <div (click)="onResetMusic('lobby')" id="resetLobbyMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                                        <span class="red-text">Reset</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="small mt-3 text-muted">End Music</div>
                                    <div class="row align-items-center">
                                        <div class="col-4" id="endMusicCol"><audio id="endMusicAudio" controls="" loop="" style="outline: none;"><source [src]="virtualEvent.value.endMusic"></audio></div>
                                        <div class="col-2">
                                            <div class="file-field">
                                                <div class="d-flex justify-content-end">
                                                    <div (click)="onChangeMusic('end')" id="changeEndMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                                        <span class="blue-text">Change</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <div class="file-field">
                                                <div class="d-flex justify-content-end">
                                                    <div (click)="onResetMusic('end')" id="resetEndMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                                        <span class="red-text">Reset</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </ng-template>
                              </mdb-accordion-item>

                          </mdb-accordion>
                    </div>
                </div>
            </mdb-tab>
            <mdb-tab title="Sponsors">
                <div class="background__color--white py-4">
                    <div class="container">
                      <div class="card__header mb-3">
                        <div class="row w-100">
                          <div class="col-12 d-flex justify-content-between">
                            <div class="card__left-side card__title d-flex">
                              <span class="d-flex align-items-center mr-2">Sponsors</span>
                              <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="onChangeSponsorMode('editor')">+ Add</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card__content">
                        <app-virtual-event-sponsor-list
                          [form]="virtualEvent"
                        ></app-virtual-event-sponsor-list>
                      </div>
                      <div class="drag-and-drop d-flex align-items-center justify-content-center mt-3">Drag and drop sponsors to reorder or use Move.</div>
                    </div>
                </div>
            </mdb-tab>
            <mdb-tab title="Slides" >
                <div class="background__color--white py-4">
                    <div class="container">
                      <div class="card__header mb-3">
                        <div class="row w-100">
                          <div class="col-12 d-flex justify-content-between">
                            <div class="card__left-side card__title d-flex">
                              <span class="d-flex align-items-center mr-2">Slides</span>
                              <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="onChangeSlideMode('editor')">+ Add</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card__content">
                        <app-virtual-event-slide-list
                          [form]="virtualEvent"
                        ></app-virtual-event-slide-list>
                      </div>
                      <div class="drag-and-drop d-flex align-items-center justify-content-center mt-3">Drag and drop slides to reorder or use Move.</div>
                    </div>
                </div>
            </mdb-tab>
          </mdb-tabs>

    </ng-container>
    <ng-container *ngIf="sponsorMode === 'editor'">
        <div class="container py-3">
            <div class="d-flex justify-content-between">
                <div class="campaign-option__back d-flex align-items-center">
                    <div class="campaign-option__arrow--back mr-2">
                      <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>Path</title>
                        <defs>
                            <filter id="filter-1">
                                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                            </filter>
                        </defs>
                        <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                            <g id="New-Option-Header" transform="translate(-25.000000, -31.000000)">
                                <g id="Header" transform="translate(25.000000, 29.000000)">
                                    <g id="Group">
                                        <g filter="url(#filter-1)" id="Title-2">
                                            <g>
                                                <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                      </svg>
                    </div>
                    <div class="campaign-option__campaign-name">Back</div>
                </div>
                <div class="d-flex justify-content-end">
                    <div class="campaign__action-list d-flex align-items-center">
                      <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onChangeSponsorMode('list')">Cancel</button>
                      <button [ngClass]="imageService.loadingClasses()" class="btn btn--paybee btn--black" (click)="onSaveSponsor()">Save Sponsor</button>
                    </div>
                </div>
            </div>
          </div>
          <div class="background__color--white py-4">
            <div class="container">
              <div class="card__content" [formGroup]="virtualEventSponsor">
                <div class="card__header">
                    <div class="card__title">Sponsor</div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="position-relative mb-4 w-100">
                            <div
                                *ngIf="virtualEventSponsor.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                                style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                                class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                            >
                                <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                            </div>
                            <div
                                *ngIf="virtualEventSponsor.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                                style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                                class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                            >
                                <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetSponsorImage()"></app-icon-delete>
                            </div>
                            <img style="border-radius: 5px" class="w-100" [src]="virtualEventSponsor.controls.imageDataUrl.value">
                        </div>
                    </div>
                </div>
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="name" label='Please provide text block title'></app-mdbp-input>
                    <span class="form-fill-error"  *ngIf="virtualEventSponsor.controls.name.hasError('required') && virtualEventSponsor.controls.name.touched ">Please provide Sponsor Name</span>
                </mdb-form-control>

                <mdb-form-control class="form-fill">
                  <app-mdbp-input mdbInput formControlName="sponsorUrl" label='Sponsor Url'></app-mdbp-input>
                  <span class="form-fill-error"  *ngIf="virtualEventSponsor.controls.sponsorUrl.hasError('pattern') && virtualEventSponsor.controls.sponsorUrl.touched">Incorrect format of Sponsor URL</span>
                  <span class="form-fill-error"  *ngIf="virtualEventSponsor.controls.sponsorUrl.hasError('url') && virtualEventSponsor.controls.sponsorUrl.touched">Incorrect format of Sponsor URL</span>
                </mdb-form-control>
              </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="slideMode === 'editor'">
        <div class="container py-3">
            <div class="d-flex justify-content-between">
                <div class="campaign-option__back d-flex align-items-center">
                    <div class="campaign-option__arrow--back mr-2">
                      <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>Path</title>
                        <defs>
                            <filter id="filter-1">
                                <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                            </filter>
                        </defs>
                        <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                            <g id="New-Option-Header" transform="translate(-25.000000, -31.000000)">
                                <g id="Header" transform="translate(25.000000, 29.000000)">
                                    <g id="Group">
                                        <g filter="url(#filter-1)" id="Title-2">
                                            <g>
                                                <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                      </svg>
                    </div>
                    <div class="campaign-option__campaign-name">Back</div>
                </div>
                <div class="d-flex justify-content-end">
                    <div class="campaign__action-list d-flex align-items-center">
                      <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onChangeSlideMode('list')">Cancel</button>
                      <button class="btn btn--paybee btn--black" (click)="onSaveSlide()">Save Slide</button>
                    </div>
                </div>
            </div>
          </div>
          <div class="background__color--white py-4">
            <div class="container">
              <div class="card__content" [formGroup]="virtualEventSlide">
                <div class="card__header">
                    <div class="card__title">Slide</div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="position-relative mb-4 w-100">
                            <div
                                *ngIf="virtualEventSlide.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                                style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                                class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                            >
                                <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                            </div>
                            <div
                                *ngIf="virtualEventSlide.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                                style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                                class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                            >
                                <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetSlideImage()"></app-icon-delete>
                            </div>
                            <img style="border-radius: 5px" class="w-100" [src]="virtualEventSlide.controls.imageDataUrl.value">
                        </div>
                    </div>
                </div>
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="name" label='Slide Name'></app-mdbp-input>
                    <span class="form-fill-error"  *ngIf="virtualEventSlide.controls.name.hasError('required') && virtualEventSlide.controls.name.touched ">Please provide Slide Name</span>
                </mdb-form-control>
              </div>
            </div>
        </div>
    </ng-container>
</ng-container>
